import { validMcpRequestId } from '../mission-control/lib/mcpConsentPolicy.js';

const consentPath = '/network-ops/mcp-consent';

/** Carry only the server's opaque request ID across sign-in. */
export function mcpLoginRequestId(search: string): string | null {
  const values = new URLSearchParams(search).getAll('oauth_request_id');
  return values.length === 1 && validMcpRequestId(values[0]) ? values[0] : null;
}

export function mcpConsentPath(search: string): string | null {
  const id = mcpLoginRequestId(search);
  return id ? `${consentPath}?oauth_request_id=${encodeURIComponent(id)}` : null;
}

export function adminLoginPath(pathname: string, search: string): string {
  const id = pathname === consentPath ? mcpLoginRequestId(search) : null;
  return id ? `/login?oauth_request_id=${encodeURIComponent(id)}` : '/login';
}
